import styles from "./styles.module.css";
import NounLoading from "assets/svg/noun-loading.svg";

const Loading = () => (
  <div className={styles.loadingContainer}>
    <div className={styles.loadingSpinner}>
      <NounLoading />
    </div>
  </div>
);

export default Loading;
